import { z } from "zod"

// user : Created by the user in the contact/properties/library
// base : Default in Ring.io
// custom : Custom properties in the old system
export const ContactPropertySourceSchema = z.enum(["user", "base", "custom"])
export type TContactPropertySource = z.infer<typeof ContactPropertySourceSchema>

export const ContactPropertyTypesSchema = z.enum(
  [
    "string",
    "number",
    "date",
    "bool",
    "date_iso",
    "date_mdy",
    "date_ymd",
    "phone",
    "enumerated",
    "formula",
  ],
  {
    invalid_type_error: "The contact property type specified is not supported",
  }
)
export type TContactPropertyTypes = z.infer<typeof ContactPropertyTypesSchema>

const ContactPropertyKeySchema = z.string({
  invalid_type_error: "Key field must be a string",
  required_error: "Key field is required",
})

const ContactPropertyLabelSchema = z
  .string({
    invalid_type_error: "Name field is not a string",
    required_error: "Name field is required",
  })
  .min(1, {
    message: "Name field must have at least 1 character",
  })

const ContactPropertyMandatorySchema = z.boolean({
  required_error: "Mandatory field is required",
  invalid_type_error: "Mandatory field must be a boolean",
})

const ContactPropertyUpdatableSchema = z.boolean({
  required_error: "Updatable field is required",
  invalid_type_error: "Updatable field must be a boolean",
})

const ContactPropertyUniqueSchema = z.boolean({
  required_error: "Unique field is required",
  invalid_type_error: "Unique field must be a boolean",
})

const ContactPropertyIDSchema = z
  .number({
    required_error: "ID field is required",
    invalid_type_error: "ID field must be a number",
  })
  .int({
    message: "ID field must be an integer",
  })
// .gt(0, {
//   message: "ID field must be greater than zero",
// })

const ContactPropertyAccountIDSchema = z
  .number({
    required_error: "Account ID field is required",
    invalid_type_error: "Account ID field must be a number",
  })
  .int({
    message: "Account ID field must be an integer",
  })
// .gt(0, {
//   message: "Account ID field must be greater than zero",
// })

export const ContactPropertyEnumeratedValueSchema = z.object({
  key: z.string(),
  value: z.string(),
  score: z.number(),
})

export type TContactPropertyEnumeratedValue = z.infer<
  typeof ContactPropertyEnumeratedValueSchema
>

export const ContactPropertySchema = z.object({
  key: ContactPropertyKeySchema,
  label: ContactPropertyLabelSchema,
  type: ContactPropertyTypesSchema,
  mandatory: ContactPropertyMandatorySchema,
  updatable: ContactPropertyUpdatableSchema,
  uniqueness: ContactPropertyUniqueSchema,
  source: ContactPropertySourceSchema.optional(),
  enumeratedValuesJson: ContactPropertyEnumeratedValueSchema.array().nullish(),
  formulaExpression: z.string().nullish(),
})
// .refine((input) => {
//   return input.name !== snakeCase(input.label)
// })
export type TContactProperty = z.infer<typeof ContactPropertySchema>

// export const ContactPropertyWithoutNameSchema = ContactPropertySchema.omit({
//   name: true,
// })

// export type TContactPropertyWithoutName = z.infer<
//   typeof ContactPropertyWithoutNameSchema
// >

export const ServerContactPropertySchema = ContactPropertySchema.extend({
  id: ContactPropertyIDSchema,
  accountId: ContactPropertyAccountIDSchema,
})
export type TServerContactProperty = z.infer<typeof ServerContactPropertySchema>

export const GetContactPropertyListServerResponseSchema =
  ServerContactPropertySchema.array()

export const ContactPropertyArraySchema = ContactPropertySchema.array()
export type TContactPropertyArray = z.infer<typeof ContactPropertyArraySchema>
